import styled from 'styled-components';

import RichText from 'components/RichText/RichText';
import { ReactComponent as SVGLinkArrow } from 'svgs/link.svg';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

interface WrapperProps {}

const { min } = layout.columns;

export const Wrapper = styled.div<WrapperProps>`
  display: block;
  position: relative;

  overflow-x: hidden;
`;

export const Container = styled.div`
  color: ${colors.black};
  padding: 88px 16px 121px;

  ${mediaDesktop(`
    padding: 144px 122px 170px;
  `)};

  h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)}
  }
  h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}
  }
  h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
  }
  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
  }
  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
  }

  blockquote {
    border-left: 3px solid;
    padding-left: 30px;

    p:last-of-type {
      margin-top: 20px;
      ${mediaDesktop(`
        margin-top: 32px;
      `)};

      ${({ theme: { locale } }) => setTypography('smallBody', locale)}
    }
  }
`;

export const Heading = styled.section`
  display: grid;
  grid-row-gap: 24px;

  ${mediaDesktop(`
    grid-row-gap: 40px;
  `)};
`;

export const Badges = styled.section`
  display: grid;
  grid-row-gap: 40px;
  margin: 48px 0 32px;

  border-bottom: 1px solid ${colors.mercury};

  ${mediaDesktop(`
    grid-row-gap: 56px;
    margin: 64px 0 56px;
  `)};
`;

export const ListWrapper = styled.div`
  min-height: 48px;
`;

export const SectionListWrapper = styled.section`
  padding-top: 12px;
  border-top: 1px solid ${colors.mercury};

  &:last-of-type {
    margin-bottom: 40px;

    ${mediaDesktop(`
      margin-bottom: 56px;
    `)};
  }
`;

export const SectionList = styled.ul`
  width: 100%;
  display: flex;
  position: absolute;
  left: 0;
  padding: 0 16px;
  overflow-x: scroll;

  margin-top: 9px;

  list-style: none;

  ${mediaDesktop(`
    display: block;
    position: relative;
    padding: 0;
    overflow-x: auto;
  `)};
`;

export const SectionListItem = styled.li`
  margin: 8px 8px 8px 0;

  display: inline-flex;
`;

export const LinkArrow = styled(SVGLinkArrow)`
  width: 12px;

  margin-right: 12px;
`;

export const Awards = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 96px;

  div:first-child {
    margin-bottom: 32px;
  }

  ${mediaDesktop(`
    grid-template-columns: repeat(${min}, 1fr);
    margin-top: 104px;

    div:first-child {
      margin: 0;
    }
  `)};
`;

export const CaseStudyRichText = styled(RichText)`
  line-height: 32px;
  p {
    line-height: 29px;
  }
`;
